module.exports = __webpack_public_path__ + "img/wu.864d1b32.png";